module.exports = __webpack_public_path__ + "img/person-walking-with-cane.656d3451.svg";